export default __webpack_public_path__ + "static/media/night-walker.28e239be.png";